import { useEffect, useState } from 'react';
import { map } from 'lodash';
import {
  SubscriptionListInput,
  SubscriptionType,
} from '../../types/subscription.types';
import SubscriptionService from '../../services/subscriptions.service';
import { getLocateDate } from '../../utils/format-date-time.utils';
import DateRangeFilter, { DateRangeType } from '../common/DateRangeFilter';

const Subscriptions = () => {
  const [subscriptions, setSubscriptions] = useState<SubscriptionType[]>([]);
  const [filteredSubscriptions, setFilteredSubscriptions] = useState<
    SubscriptionType[]
  >([]);
  const [totalSubscriptionCount, setTotalSubscriptionCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState<DateRangeType>({
    startDate: undefined,
    endDate: undefined,
  });
  const limit = 20;

  const getFilteredSubscriptions = async () => {
    try {
      setLoading(true);
      const input: SubscriptionListInput = {
        limit,
        offset: filteredSubscriptions.length,
        startDate: dates.startDate,
        endDate: dates.endDate,
      };
      const response = await SubscriptionService.getSubscriptions(input);
      if (response.data.data && response.data.data.subscriptions) {
        setSubscriptions(response.data.data.subscriptions);
        setTotalSubscriptionCount(response.data.data.totalSubscriptions);
        setFilteredSubscriptions([
          ...filteredSubscriptions,
          ...response.data.data.subscriptions,
        ]);
      } else {
        console.log('Error: ', response.data.message);
      }
      setLoading(false);
    } catch (err) {
      console.log('Error: ', err);
      setLoading(false);
    }
  };

  const getAllSubscriptions = async (isFetchMore?: boolean) => {
    try {
      setLoading(true);
      const input: SubscriptionListInput = {
        limit,
        offset: subscriptions.length,
      };
      const response = await SubscriptionService.getSubscriptions(input);
      if (response.data.data && response.data.data.subscriptions) {
        if (subscriptions.length === 0) {
          setTotalSubscriptionCount(response.data.data.totalSubscriptions);
        }
        setSubscriptions(
          isFetchMore
            ? [...subscriptions, ...response.data.data.subscriptions]
            : response.data.data.subscriptions
        );
      } else {
        console.log('Error: ', response.data.message);
      }
      setLoading(false);
    } catch (err) {
      console.log('Error: ', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllSubscriptions();
  }, []);

  useEffect(() => {
    if (!dates.startDate || !dates.endDate) return;
    getFilteredSubscriptions();
  }, [dates]);

  const handleScroll = (e: any) => {
    if (
      e.target.scrollTop + e.target.clientHeight + 50 >=
        e.target.scrollHeight &&
      !loading &&
      susbscriptionList.length < totalSubscriptionCount
    ) {
      if (filteredSubscriptions.length > 0) {
        getFilteredSubscriptions();
      } else {
        getAllSubscriptions(true);
      }
    }
  };

  const susbscriptionList: SubscriptionType[] =
    filteredSubscriptions.length > 0 ? filteredSubscriptions : subscriptions;

  return (
    <div className="overflow-y-auto w-full p-5">
      <div className="flex justify-between items-center mb-8">
        <h3 className="font-normal text-[40px]">Subscription Payments</h3>
        <DateRangeFilter
          setDateRange={(values) => setDates(values)}
          dateRange={dates}
        />
      </div>
      <div
        className="overflow-x-auto p-5 rounded-2xl shadow-[0_0_8px_#cbcbcb] max-h-[calc(100%-100px)] overflow-y-auto"
        onScroll={handleScroll}
      >
        <table className="text-[14px] bg-white min-w-full">
          <thead className="text-left">
            <tr className="text-[#616161]">
              <th>Name</th>
              <th>Email</th>
              <th>Type</th>
              <th>Price</th>
              <th>Interval</th>
              <th>Created At</th>
              <th>Next Payment Date</th>
              <th>View Details</th>
            </tr>
          </thead>
          <tbody className="text-[#333] font-regular">
            {susbscriptionList &&
              susbscriptionList.length > 0 &&
              map(subscriptions, (subscription) => (
                <tr className="static rounded-lg border-b-8 border-white last:border-none">
                  <td className="px-3 py-5 first:font-semibold bg-[#fcfcfc]">{`${subscription?.user?.firstName} ${subscription?.user?.lastName}`}</td>
                  <td className="px-3 py-5 first:font-semibold bg-[#fcfcfc]">
                    {subscription?.user?.email}
                  </td>
                  <td className="px-3 py-5 bg-[#fcfcfc]">
                    {subscription?.plan?.product?.name}
                  </td>
                  <td className="px-3 py-5 bg-[#fcfcfc]">
                    {subscription?.price ?? 0}
                  </td>
                  <td className="px-3 py-5 bg-[#fcfcfc]">
                    {subscription?.interval ?? '--'}
                  </td>
                  <td className="px-3 py-5 bg-[#fcfcfc]">
                    {subscription?.createdAt &&
                      getLocateDate(subscription?.createdAt)}
                  </td>
                  <td className="px-3 py-5 bg-[#fcfcfc]">
                    {subscription?.nextPaymentDate &&
                      getLocateDate(subscription?.nextPaymentDate)}
                  </td>
                  <td className="px-3 py-5 bg-[#fcfcfc]">
                    <span className="font-bold">View Details</span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Subscriptions;
